export const AppInfo = {
    version: __SMART_DIAGNOSTICS_VERSION__,
    // DO NOT CHANGE BUILD: AUTOMATICALLY CHANGED BY PIPELINE
    build: 1553,
    // DO NOT CHANGE RELEASE: AUTOMATICALLY CHANGED BY PIPELINE
    release: true,

    displayVersion,
};

function displayVersion() {
    return AppInfo.release
        ? `${AppInfo.version}+${AppInfo.build}`
        : `${AppInfo.version}-prerelease`;
}
